
class ShippingCalculator extends HTMLElement {
  constructor() {
    super();
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#wrapper-response');
    this.zip = this.querySelector('#address_zip');
    this.country = this.querySelector('#address_country');
    this.province = this.querySelector('#address_province');
    this.button = this.querySelector('.get-rates');

    // Initialize country-province selector
    new Shopify.CountryProvinceSelector('address_country', 'address_province', {
      hideElement: 'address_province_container'
    });

    // Bind event
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  onSubmitHandler() {
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });

    fetch(`${window.routes.cart_url}/shipping_rates.json`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(parsedState => {
        if (parsedState.shipping_rates) {
          this.success.innerHTML = parsedState.shipping_rates
            .map(rate => `<p>${rate.name}: ${rate.price} ${Shopify.currency.active}</p>`)
            .join('');
          this.success.classList.remove('hidden');
        } else {
          this.errors.querySelector('.errors').innerHTML = Object.entries(parsedState)
            .map(([attr, messages]) => `${attr.charAt(0).toUpperCase() + attr.slice(1)} ${messages[0]}`)
            .join('; ');
          this.errors.classList.remove('hidden');
        }
      })
      .catch(console.error)
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);

(function () {
 function formatMoney(cents) {
  var value = cents / 100;
  var isArabic = document.documentElement.lang === "ar";

  var formatted = Number.isInteger(value)
    ? value.toString()
    : value.toFixed(2).replace(/\.00$/, '');

  if (isArabic) {
    return formatted + " د.إ";
  } else {
    return formatted + " AED";
  }
}


  async function updateFreeShippingBox() {
    var box = document.querySelector(".free-shipping-box");
    if (!box) return;

    var threshold = parseInt(box.getAttribute("data-threshold"), 10) || 25000;
    var moneyFormat = box.getAttribute("data-money-format");

    try {
      var res = await fetch("/cart.js", { credentials: "same-origin" });
      var cart = await res.json();

      var total = cart.total_price;
      var remaining = threshold - total;
      var progress = Math.min(100, Math.round((total * 100) / threshold));

      var fillEl = box.querySelector(".free-shipping-bar__fill");
      if (fillEl) {
        fillEl.style.width = progress + "%";
        if (progress >= 100) fillEl.style.backgroundColor = "#1b5e20";
        else if (progress >= 80) fillEl.style.backgroundColor = "#2e7d32";
        else if (progress >= 40) fillEl.style.backgroundColor = "#f4b400";
        else fillEl.style.backgroundColor = "#b0b0b0";
      }

      var textEl = box.querySelector(".free-shipping-text");
      if (!textEl) return;

      var isArabic = document.documentElement.lang === "ar";

if (remaining > 0) {
  textEl.classList.remove("success");
  textEl.innerHTML = isArabic
    ? 'شحن مجاني للطلبات فوق <strong><bdi>350 درهم</bdi></strong><br>' +
      'المتبقي: <strong class="free-shipping-remaining"><bdi>' +
      formatMoney(remaining, moneyFormat) +
      '</bdi></strong><span class="free-shipping-suffix"><bdi>للحصول على شحن مجاني</bdi></span>'
    : 'Free shipping for orders over <strong><bdi>350 AED</bdi></strong><br>' +
      'Remaining: <strong class="free-shipping-remaining"><bdi>' +
      formatMoney(remaining, moneyFormat) +
      '</bdi></strong><span class="free-shipping-suffix"><bdi>to get free shipping</bdi></span>';
} else {
  textEl.classList.add("success");
  textEl.innerHTML = isArabic
    ? '🎉 مبروك! تم تفعيل <strong>الشحن المجاني</strong>'
    : '🎉 Congrats! You’ve unlocked <strong>FREE shipping</strong>';
}

    } catch (e) {}
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  var safeUpdate = debounce(updateFreeShippingBox, 200);

  function observeDrawer() {
    var target = document.getElementById("CartDrawer");
    if (!target) return;

    var obs = new MutationObserver(function () {
      safeUpdate();
    });

    obs.observe(target, { childList: true, subtree: true, attributes: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
    updateFreeShippingBox();
    observeDrawer();
  });

  document.addEventListener("click", function () {
    safeUpdate();
  });

  document.addEventListener("change", function () {
    safeUpdate();
  });
})();


